import React, { useEffect } from 'react'
import { Routes as RouterRoutes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import * as PAGE from './pagesImport'
import { GlobalStyle } from 'styles/global-styles'
import { NotFoundPage } from './components/NotFoundPage/Loadable'
import { useToken } from './hooks'
import { LogoutPage } from './CMSPages/CMSLogoutPage'
import { GomsAcademy } from './gomsacademy/organism/Main/index'
import { Dailyreport } from "./gomsacademy/organism/Dailyreport";

export function Routes() {
	const { data: token } = useToken()

	useEffect(() => {
		console.log('token', token);
	}, [token]);

	return (
		<BrowserRouter>
			<GlobalStyle />
			<RouterRoutes>
				<Route path="/" element={token ? <Navigate to="/admin" replace /> : <PAGE.LoginPage />} />
				<Route path="/admin" element={token ? <GomsAcademy /> : <PAGE.LoginPage />} />
				<Route path="/admin/login" element={token ? <GomsAcademy /> : <PAGE.LoginPage />} />
				<Route path="/admin/logout" element={<LogoutPage />} />
				{/* ** 학원생 관리 시스템 ===== */}
				<Route path="/admin/academy/*" element={token ? <GomsAcademy /> : <PAGE.LoginPage />} />
				<Route path='/dailyreport' element={<Dailyreport selectLecture={null} selectStudentNote={null} setManageSt={() => {}} editNoteIndex={null} handleWriteClick={() => {}} setIsWrite={() => {}} />} />
				<Route path="*" element={<NotFoundPage />} />
			</RouterRoutes>
		</BrowserRouter>
	)
}
